import { render, staticRenderFns } from "./settings-organization-order-attribution.vue?vue&type=template&id=9105172e&scoped=true&"
import script from "./settings-organization-order-attribution.vue?vue&type=script&lang=js&"
export * from "./settings-organization-order-attribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9105172e",
  null
  
)

export default component.exports